import { render } from "./NrgItems.vue?vue&type=template&id=da229dca"
import script from "./NrgItems.vue?vue&type=script&lang=js"
export * from "./NrgItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__